// src/components/sidebar/ProSidebarLayout.tsx
import React from 'react';
import '../../../src/styles/ProSidebarBase.css';
import { Outlet } from 'react-router-dom';
import ProSidebarBase, { NavItem } from './ProSidebarBase';
import AdminSidebar from './AdminSidebar';

const AdminSidebarLayout = () => {
  return (
    <div className="app-layout">
      <AdminSidebar />
      <main className="app-main">
        <div className="app-main-inner">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminSidebarLayout;
